<div class="oase-fragebogen">

	<mat-card appearance="outlined">
		<mat-card-title>
			{{ OBJ_LNG_NAME+'.liste' | translate:locale.language }} <span *ngIf="dataSource" class="anzahl"> ({{ 'allgemein.daten.insgesamt' | translate:locale.language:{ count: dataSource.page.totalElements } }})</span>
			<p class="errors" *ngIf="dataService.fehler" [innerHTML]="dataService.fehler.messagehtml"></p>
			<p class="errors" *ngIf="fehlerMain" [innerHTML]="fehlerMain.messagehtml"></p>
		</mat-card-title>

		<mat-card-content>

			<div class="tabelle">
				<div class="tabelle-kopf" [style.display]="">
					<mat-form-field>
						<input matInput #filter>
						<mat-label>
							<i class="material-icons app-input-icon">search</i> {{ 'allgemein.suche' | translate:locale.language }}
						</mat-label>
						<button matSuffix mat-icon-button class="suche" (click)="clearFilter()" matTooltip="{{ 'allgemein.klick.leeresuche' | translate:locale.language }}"
								[disabled]="dataSource.isWaitingForResponse || filter.value == ''"><mat-icon>close</mat-icon></button>
					</mat-form-field>
				</div>

				<!-- Wenn eine Auswahl nicht benötigt wird einfach in displayedColumns die Spalte select nicht einbinden -->

				<div class="ladedaten" *ngIf="dataSource.isWaitingForResponse">
					<div>{{ 'allgemein.daten.laden.start' | translate:locale.language }} <mat-icon>free_breakfast</mat-icon></div>
					<div><mat-spinner color="primary"></mat-spinner></div>
					<div>{{ 'allgemein.daten.laden.ende' | translate:locale.language }}</div>
				</div>

				<mat-table #table [dataSource]="dataSource" matSort  [style.display]="onDesktop()">

					<ng-container matColumnDef="title">
						<mat-header-cell *matHeaderCellDef fxFlex="40.94">{{ OBJ_LNG_NAME+'.title' | translate:locale.language }}</mat-header-cell>
						<mat-cell fxFlex="40.94" *matCellDef="let row">
							{{ row.name }}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="ablaufdatum">
						<mat-header-cell *matHeaderCellDef  fxFlex="10.94">{{ OBJ_LNG_NAME+'.ablaufdatum' | translate:locale.language }}</mat-header-cell>
						<mat-cell fxFlex="10.94" *matCellDef="let row">
							{{ row.ablaufdatumFormat }}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="typ">
						<mat-header-cell *matHeaderCellDef  fxFlex="20.75">{{ OBJ_LNG_NAME+'.fragebogen-typ' | translate:locale.language }}</mat-header-cell>
						<mat-cell fxFlex="20.75" *matCellDef="let row">

							{{ row.typ }}

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="status">
						<mat-header-cell *matHeaderCellDef  fxFlex="15.53">{{ OBJ_LNG_NAME+'.status' | translate:locale.language }}</mat-header-cell>
						<mat-cell fxFlex="15.53" *matCellDef="let row">

						<span *ngIf="row.status == 1" class="warn-font" style="font-weight:600;">{{ OBJ_LNG_NAME+'.warten' | translate:locale.language }}</span>
						<span *ngIf="row.status == 2" class="primary-font" style="font-weight:600;">{{ OBJ_LNG_NAME+'.abgeschlossen' | translate:locale.language }}</span>

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="aktion">
						<mat-header-cell *matHeaderCellDef  fxFlex="11.84">{{ OBJ_LNG_NAME+'.aktion' | translate:locale.language }}</mat-header-cell>
						<mat-cell fxFlex="11.84" *matCellDef="let row">

						<button mat-raised-button *ngIf="row.status == 0" [routerLink]="['/protected/frageantwort-fb',row.id,0]">{{ 'allgemein.start' | translate:locale.language }}</button>
						<button mat-raised-button *ngIf="canRestartFragebogen(row)" [routerLink]="['/protected/frageantwort-fb',row.id,0]">{{ 'allgemein.restart' | translate:locale.language }}</button>
						<button mat-raised-button *ngIf="canViewFragebogen(row)" [routerLink]="['/protected/frageantwort-fb',row.id,1]"><mat-icon>remove_red_eye</mat-icon></button>
						</mat-cell>
					</ng-container>

					<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: displayedColumns; let i = index;" ></mat-row>

				</mat-table>

				<div class="sucheleer" [style.display]="dataSource.page.totalElements > 0 && dataSource.page.searchElements == 0 ? '' : 'none'">
					{{ 'allgemein.daten.sucheleer' | translate:locale.language }}
				</div>

				<div class="keinedaten" [style.display]="dataSource.page.totalElements == 0 ? '' : 'none'">
					{{ 'allgemein.daten.keine' | translate:locale.language }}
				</div>

				<mat-paginator #paginator
							   [length]="dataSource.page.searchElements"
							   [pageIndex]="0"
							   [pageSize]="10"
							   [pageSizeOptions]="[5,10,15,20,25,30,50,100,200,500]">
				</mat-paginator>
			</div>
		</mat-card-content>
	</mat-card>

	<div [style.display]="onMobile()" class="mobile">
		<mat-card appearance="outlined" *ngFor="let fragebogen of dataSource.content" [ngClass]="{'green-bg': fragebogen.status==2, 'warn-bg': fragebogen.status==1}">
			<mat-card-title>
				{{ fragebogen.name }}
			</mat-card-title>
			<mat-card-subtitle>
				{{ OBJ_LNG_NAME+'.ablaufdatum' | translate:locale.language }}: {{ fragebogen.ablaufdatumFormat }}
			</mat-card-subtitle>
			<mat-card-content>
				{{ OBJ_LNG_NAME+'.typ' | translate:locale.language }}: {{ fragebogen.typ }}
			</mat-card-content>
			<mat-card-actions align="end">
				<button mat-raised-button *ngIf="fragebogen.status == 0" [routerLink]="['/protected/frageantwort-fb',fragebogen.id,0]">{{ 'allgemein.start' | translate:locale.language }}</button>
				<button mat-raised-button *ngIf="canRestartFragebogen(fragebogen)" [routerLink]="['/protected/frageantwort-fb',fragebogen.id,0]">{{ 'allgemein.restart' | translate:locale.language }}</button>
				<button mat-raised-button *ngIf="canViewFragebogen(fragebogen)" [routerLink]="['/protected/frageantwort-fb',fragebogen.id,1]"><mat-icon>remove_red_eye</mat-icon></button>
			</mat-card-actions>
		</mat-card>

	</div>

</div>

